import { render, staticRenderFns } from "./CourseReviewPage.vue?vue&type=template&id=6e7c9e8c&scoped=true"
import script from "./CourseReviewPage.vue?vue&type=script&lang=js"
export * from "./CourseReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c9e8c",
  null
  
)

export default component.exports